import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { ConfiguracoesProjeto, GenericHttpService, ParametrosService } from '..';
import { TipoResponsabilidadeRepresentanteLegalModel } from '../model/tipo-responsabilidade-representante-legal.model';

@Injectable()
export class TipoResponsabilidadeRepresentanteLegalService {
  public _urlBase: string;
  public configuracao: ConfiguracoesProjeto;

  public tiposResponsabilidadesRepresentanteLegal: TipoResponsabilidadeRepresentanteLegalModel[];
  public tiposResponsabilidadesRepresentanteLegalChange = new Subject<TipoResponsabilidadeRepresentanteLegalModel[]>();
  public tiposResponsabilidadesRepresentanteLegalErro = '';

  constructor(
    private readonly genericHttpService: GenericHttpService<TipoResponsabilidadeRepresentanteLegalModel>,
    private readonly parametrosService: ParametrosService
  ) {}

  get urlBase() {
    this.configuracao = this.parametrosService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'tipo-representante/';

    return this._urlBase;
  }

  public getTiposResponsabilidadesRepresentanteLegal() {
    const api = `listagem`;

    this.genericHttpService.getById(this.urlBase + api).subscribe(
      (data: any) => {
        this.tiposResponsabilidadesRepresentanteLegal = <TipoResponsabilidadeRepresentanteLegalModel[]>data;
        this.tiposResponsabilidadesRepresentanteLegalErro = '';
        this.tiposResponsabilidadesRepresentanteLegalChange.next(this.tiposResponsabilidadesRepresentanteLegal.slice());
      },
      (error: any) => {
        this.tiposResponsabilidadesRepresentanteLegal = [];
        this.tiposResponsabilidadesRepresentanteLegalErro = error;
        this.tiposResponsabilidadesRepresentanteLegalChange.next(this.tiposResponsabilidadesRepresentanteLegal.slice());
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/tipo-responsabilidade-representante-legal.service.ts